import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  logout() {
    this.authService.logout();
    return this.router.navigate(['']);
  }

  routeTo(route: string): Promise<boolean> {
    return this.router.navigateByUrl(route);
  }

  checkRouteMatching(route: string): boolean {
    return this.router.url == route;
  }
}
